module.exports = __webpack_public_path__ + "static/media/sportnet-logo-light.0b991e28.svg";